<div class="chip" [ngStyle]="{ 'background-color': bgColor, color: textColor }">
	{{ text }}
</div>
